"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLockCloseOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M6 9.002l.002-2C6 3.667 8 2 12 2s6 1.667 6 5.002v2c1.333 0 2 .667 2 2v9c0 1.333-.667 2-2 2H6.002c-1.335 0-2.002-.667-2.002-2V11.03c0-1.351.667-2.027 2-2.027v-.001zm0 11h12v-9.018H6v9.018zm5-3v-3c0-.667.333-1 1-1s1 .333 1 1v3c0 .667-.333 1-1 1s-1-.333-1-1zm5.003-8c0-3 0-5-4.003-5s-4 2-4 5h8.003z' }))); };
exports.default = SvgLockCloseOutline;
//# sourceMappingURL=LockCloseOutline.js.map